<template>
  <div id="head-app">
    <header id="site-header" :class="color">
      <figure class="logo" :class="{'hide': toggle}">
        <a :href="link">
          <img :src="logo" :alt="alt" :class="color" />
          <span v-if="text">{{ text }}</span>
        </a>
      </figure>

      <ul class="gnavi" :class="{'hide': toggle}">
        <li v-for="(item, index) in list" :key="index"><a :href="item.link" :class="color">{{item.name}}</a></li>
      </ul>
      
      <div class="menu" @click="toggle = !toggle" :class="color">
        <div class="menu__icon" :class="{'active': toggle}">
          <i v-for="n of 3" :key="n"></i>
        </div>
        <div class="menu__text" v-if="!toggle">MENU</div>
        <div class="menu__text" v-else>閉じる</div>
      </div>
    </header>

    <div class="sns">
      <Sns cate="line" link="https://lin.ee/NjqE7R2" text="お友達登録はこちら" />
      <Sns cate="insta" link="https://www.instagram.com/kidspower_olinace?igsh=NWVvb3Z4eTk2bWdo" text="Instagramを見る" />
      <Sns cate="tiktok" link="https://www.tiktok.com/@olinace_official?_r=1&_t=ZS-98qF8A1uhBi" text="TikTokを見る" />
      <Sns cate="youtube" link="https://youtube.com/@kidspower-olinace?si=eFEEt6Ong1rRWzGZ" text="YouTubeを見る" />
    </div>


    <Transition name="menu">
      <Navigation v-if="toggle" />
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
$menuSize: 6.4rem;
header{
  width: 100%;
  height: $menuSize;
  position: absolute;
  padding: 1.12rem module.side();
  display: grid;
  grid-template-columns: auto auto;
  z-index: 1000;
  &.red{
    .gnavi{
      padding: 1.2rem 2rem;
      border-radius: 999rem;
      background: module.$white;
    }
  }
  > *{
    align-self: center;
  }
  .logo{
    transition: opacity 400ms module.$ease;
    &.hide{
      opacity: 0;
      pointer-events: none;
    }
    >*{
      align-self: center;
    }
    a{
      color: module.$normal;
      @include module.flex();
      align-items: flex-end;
      justify-content: flex-start;
      gap: 1.2rem;
    }
    img{
      width: 8rem;
      &.blue,
      &.orange,
      &.green{
        width: 11rem;
      }
    }
  }
  .gnavi{
    font-size: .96rem;
    position: absolute;
    top: 50%;
    right: 9.2rem;
    z-index: 2;
    @include module.flex();
    align-items: center;
    justify-content: flex-start;
    gap: 2rem;
    transition: opacity 400ms module.$ease;
    transform: translateY(-50%);
    @media screen and (max-width: 1200px){
      gap: 1.2rem;
    }
    &.hide{
      opacity: 0;
      pointer-events: none;
    }
    li{
      a{
        font-size: 1.08rem;
        white-space: nowrap;
        color: module.$normal;
        position: relative;
        transition: color 200ms module.$ease;
        @media screen and (max-width: 1200px){
          font-size: 1rem;
        }
        &.blue{
          &:hover{
           color: module.$blue; 
          }
          &:before{
            background: module.$blue;
          }
        }
        &.orange{
          &:hover{
           color: module.$orange; 
          }
          &:before{
            background: module.$orange;
          }
        }
        &.green{
          &:hover{
           color: module.$green; 
          }
          &:before{
            background: module.$green;
          }
        }
        &:hover{
          color: module.$main;
          &:before{
            width: 2.4rem;
          }
        }
        &:before{
          content: '';
          width: 0;
          height: 2px;
          background: module.$main;
          position: absolute;
          left: 50%;
          bottom: -.4rem;
          transform: translateX(-50%);
          transition: width 200ms module.$ease;
        }
      }
    }
  }
  .menu{
    position: fixed;
    top: 0;
    right: 0;
    width: $menuSize;
    height: $menuSize;
    overflow: hidden;
    background: module.$main;
    border-radius: 0 0 0 1rem;
    @include module.flex();
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 1.6rem 0 1.2rem;
    cursor: pointer;
    user-select: none;
    &.blue{
      background: module.$blue;
    }
    &.orange{
      background: module.$orange;
    }
    &.green{
      background: module.$green;
    }
    &:hover{
      &:before{
        width: 100%;
        right: auto;
        left: 0;
      }
    }
    &:before{
      content: '';
      width: 0;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      background: module.$black;
      z-index: 1;
      transition: width 200ms module.$ease;
    }
    &__icon{
      align-items: center;
      width: 40%;
      height: 40%;
      position: relative;
      z-index: 2;
      &.active{
        i{
          &:nth-child(1),
          &:nth-child(2){
            transform: translate(-50%, -50%) scale(.8) rotate(45deg);
            top: 50%;
          }
          &:nth-child(3){
            width: 0;
          }
          &:nth-child(2){
            transform: translate(-50%, -50%) scale(.8) rotate(-45deg);
          }
        }
      }
      i{
        background: module.$white;
        width: 100%;
        height: 1px;
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
        transition: all 200ms module.$ease;
        &:nth-child(1){
          top: calc(50% - 8px);
        }
        &:nth-child(2){
          top: calc(50% + 8px);
        }
      }
    }
    &__text{
      font-size: .8rem;
      letter-spacing: .12rem;
      width: 100%;
      color: module.$white;
      padding: .2rem 0 0;
      position: relative;
      z-index: 2;
    }
  }
}
.sns{
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 2000;
  transform: translateY(-50%);
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
  border-radius: .64rem 0 0 .64rem;
  box-shadow: -.4rem .4rem 2.4rem rgba(module.$normal,.12);
  > *{
    border-bottom: module.$border 1px solid;
    &:last-of-type{
      border: none;
    }
  }
}
.menu-enter-active,
.menu-leave-active {
  transition: opacity 0.5s ease;
}

.menu-enter-from,
.menu-leave-to {
  opacity: 0;
}
</style>

<style lang="scss">
header{
  .resv__btn{
    span{
      height: 100%;
      padding: 0;
      border-radius: 0;
      gap: .4rem;
      &:after{
        border-radius: 0;
        background: module.tone(module.$main, 4);
      }
    }
    &:before{
      background: module.tone(module.$main, 2);
      border-radius: 0;
    }
  }
}
</style>

<script>
import { ref } from 'vue';
import Btn from './Btn.vue'
import Navigation from './Navigation.vue'
import Sns from './Sns.vue'
export default {
  components: {
    Btn: Btn,
    Navigation: Navigation,
    Sns: Sns,
  },
  props: {
    logo : { required: true, },
    alt : { required: false, default: 'キッズパワー株式会社' },
    link : { required: false, default: '/' },
    text : { required: false, default: '' },
    list : { required: true, type: Array },
    color : { default: 'red' },
  },
  setup(){
    const toggle = new ref(false)
    return {
      toggle
    }
  }
}
</script>
